export function getAddressCoordinatesFieldName(index: number): string {
  return index === 0
    ? 'sourcePoint.address.coordinates'
    : (`destinationPoints.${index - 1}.address.coordinates` as const)
}
